import { render, staticRenderFns } from "./ManageStats.vue?vue&type=template&id=3dcc7bf8&scoped=true"
import script from "./ManageStats.vue?vue&type=script&lang=js"
export * from "./ManageStats.vue?vue&type=script&lang=js"
import style0 from "./ManageStats.vue?vue&type=style&index=0&id=3dcc7bf8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcc7bf8",
  null
  
)

export default component.exports